import { render, staticRenderFns } from "./offerhelp.vue?vue&type=template&id=2d474b08&"
import script from "./offerhelp.vue?vue&type=script&lang=js&"
export * from "./offerhelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d474b08')) {
      api.createRecord('2d474b08', component.options)
    } else {
      api.reload('2d474b08', component.options)
    }
    module.hot.accept("./offerhelp.vue?vue&type=template&id=2d474b08&", function () {
      api.rerender('2d474b08', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2JQ25hwKUE9fQ/JS/comp/offerhelp.vue"
export default component.exports